import {observable, action} from 'mobx';
import questions from '../assets/data/questions2.json';

class Game2Store {

    @observable teamColors = [
        {
            color: "red",
            name: "Red"
        },
        {
            color: "green",
            name: "Green"
        },
        {
            color: "yellow",
            name: "Yellow"
        }, {
            color: "cyan",
            name: "Blue"
        }];

    @observable numberRounds = 8;
    @observable teamsComposition = [
        {
            teams: 2,
            participants: 6,
        }
    ];
    @observable numberPlayers = 2;
    @observable extraPoints = false;
    @observable bonusPoint = 15;
    @observable answers = [
        {
            label: "Correct answer",
            points: 10,
        },
        {
            label: "Incorrect answer",
            points: 0,
        }
    ];
    @observable levels = [];
    @observable questions = []; // All questions
    @observable players = []; // Players Selected with updated scores
    @observable situation = 0;
    @observable winner; // Game's Winner
    @observable loser; //Game's Loser;
    @observable round = 1;
    @observable isLoading = false;
    @observable selectedAnswer = -1;
    @observable actualPlayer = null;
    @observable nextTurn = 0;
    @observable playerTurn1 = 0;
    @observable playerTurn2 = 0;
    @observable winners = [];
    @observable turn = 0;
    @observable pause = false;
    @observable start = false;

    @action
    resetGame() {
        this.levels = [];
        this.questions = [];
        this.round = 1;
        this.selectedAnswer = -1;
        this.actualPlayer = null;
        this.alreadyPlayed = [];
        this.winners = [];
        this.players = [];
    }

    @action
    loadQuestions() {
        this.questions = questions;
        this.levels = Object.keys(questions).map(
            (level, index) => ({id: index, name: level})
        );
    }

    @action
    setPlayers(numberPlayers) {
        let p = [];
        for (let i = 0; i < numberPlayers; i++) {
            const player = {
                name: this.teamColors[i].name + " team",
                team: this.teamColors[i],
                levels: [],
                score: 0,
            };

            p.push(player);
        }

        // Modify the state only one time
        this.players = p;
        this.numberPlayers = p.length;
    }

    @action
    setSituation(situation) {
        this.situation = situation;
    }

    @action
    changeRound() {
        this.alreadyPlayed = [];
    }

    @action
    setLevelToPlayerAt(player, level, index) {
        // Prevent insert level to index out of bounds
        if (player.levels.length < index) {
            player.levels.length = index;
        }

        player.levels[index] = level;
    }

    @action
    setPlayersTurn() {
        let randomPlayer = Math.floor(Math.random() * this.players.length);

        this.nextTurn = randomPlayer;

        this.playerTurn1 = randomPlayer;
        this.playerTurn2 = 1 === randomPlayer ? 0 : 1;
    }

    @action
    getPlayerTurn() {
        let turn = this.nextTurn;
        this.nextTurn = turn === 0 ? 1 : 0;

        return this.players[turn];
    }

    @action
    getRandomQuestionByLevel(levels) {
        // Get random level
        let level = levels[Math.floor(Math.random() * levels.length)];

        // TODO: improve this loop removing "N/A" and undefined from levels
        while (level === "N/A" || level === undefined) {
            console.log('repetiu para sempre');
            level = levels[Math.floor(Math.random() * levels.length)];
        }

        // Get random question
        const questionsByLevel = this.questions[level];
        const questionIndex = Math.floor(Math.random() * questionsByLevel.length);
        const question = questionsByLevel[questionIndex];

        // Remove question to NOT REPEAT
        this.questions[level] = [...this.questions[level].filter(q => q !== question)];

        return {statement: question, level};
    }
}

export default new Game2Store();


// WEBPACK FOOTER //
// ./src/stores/Game2Store.js